document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const sections = document.querySelectorAll('[data-prevent-autoplay="true"]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (!section) return;

      // Kill autoplay ONLY within this section
      section.querySelectorAll('video-media[autoplay] video').forEach(function(video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.currentTime = 0;
        const parent = video.closest('video-media');
        if (parent) parent.removeAttribute('autoplay');

        video.style.pointerEvents = 'auto';
        video.style.cursor = 'pointer';

        video.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });
      });

      // Play button logic scoped to this section
      section.querySelectorAll('video-media.video-with-play-button').forEach(function(wrapper) {
        const video = wrapper.querySelector('video');
        if (!video) return;

        wrapper.style.position = 'relative';

        const overlay = document.createElement('div');
        overlay.className = 'custom-video-click-overlay';
        wrapper.appendChild(overlay);

        const playBtn = document.createElement('div');
        playBtn.className = 'custom-play-button';
        playBtn.innerHTML = `
          <svg role="presentation" fill="none" focusable="false" class="icon icon-play-button" viewBox="0 0 48 48">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24Zm-3-19.15a.3.3 0 0 0 .462.253l7.545-4.85a.3.3 0 0 0 0-.505l-7.545-4.85a.3.3 0 0 0-.462.252v9.7Z" fill="currentColor"></path>
          </svg>
        `;
        wrapper.appendChild(playBtn);

        let fakeHoverInterval = null;

        const showButton = () => {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
          video.removeAttribute('controls');
        };

        const hideButton = () => {
          playBtn.style.opacity = '0';
          playBtn.style.pointerEvents = 'none';
          video.setAttribute('controls', 'controls');
          video.controls = true;
          video.muted = false;

          if (!fakeHoverInterval) {
            fakeHoverInterval = setInterval(() => {
              video.dispatchEvent(new Event('mousemove'));
            }, 2000);
          }
        };

        const stopFakeHover = () => {
          if (fakeHoverInterval) {
            clearInterval(fakeHoverInterval);
            fakeHoverInterval = null;
          }
        };

        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          video.paused ? video.play() : video.pause();
        });

        overlay.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });

        video.addEventListener('play', hideButton);
        video.addEventListener('pause', () => {
          stopFakeHover();
          showButton();
        });

        video.paused ? showButton() : hideButton();
      });
    });
  }, 400); // slight delay to let Impact's autoplay scripts run first
});

function runNonCritical(task, options) {
  if (typeof task !== 'function') return;

  const config = options || {};
  const timeout = typeof config.timeout === 'number' ? config.timeout : 1500;
  const fallbackDelay = typeof config.fallbackDelay === 'number' ? config.fallbackDelay : 1;

  const invoke = function () {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        task();
      }, { timeout: timeout });
      return;
    }

    setTimeout(task, fallbackDelay);
  };

  if (document.readyState === 'complete') {
    invoke();
    return;
  }

  window.addEventListener('load', invoke, { once: true });
}



(function () {

  function initMarquees(root = document) {
    root.querySelectorAll('.marquee-text').forEach(marquee => {

      // Prevent double init
      if (marquee.dataset.marqueeInit === 'true') return;
      marquee.dataset.marqueeInit = 'true';

      const marqueeTrack = marquee.querySelector('.marquee-text-track');
      if (!marqueeTrack) return;

      let items = Array.from(marqueeTrack.children);

      if (!items.length) {
        console.warn('No marquee items found.');
        return;
      }

      function startWhenReady() {
        if (marquee.dataset.marqueeStarted === 'true') return;
        marquee.dataset.marqueeStarted = 'true';

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(startMarquee);
        } else {
          setTimeout(startMarquee, 100);
        }
      }

      function startMarquee() {
        let contentWidth = 0;

        // Measure width safely
        items.forEach(item => {
          contentWidth += item.offsetWidth;
        });

        // Bail and retry if layout not ready
        if (contentWidth === 0) {
          setTimeout(startMarquee, 100);
          return;
        }

        const containerWidth = marquee.clientWidth || window.innerWidth;

        // Duplicate until wide enough
        while (contentWidth < containerWidth * 2) {
          items.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeTrack.appendChild(clone);
            contentWidth += clone.offsetWidth;
          });
        }

        const isMobile = window.innerWidth <= 768;
        const scrollDuration = parseFloat(
          marquee.dataset[isMobile ? 'scrollDurationMobile' : 'scrollDurationDesktop']
        ) || 80;

        const pixelsPerSecond = contentWidth / scrollDuration;
        let scrollPosition = 0;

        function animate() {
          scrollPosition -= pixelsPerSecond / 60;

          if (Math.abs(scrollPosition) >= contentWidth / 2) {
            scrollPosition = 0;
          }

          marqueeTrack.style.transform = `translateX(${scrollPosition}px)`;
          requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
      }

      // Start only when near the viewport to reduce initial work.
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      if (!isDesignMode && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            startWhenReady();
          });
        }, { rootMargin: '250px 0px' });

        observer.observe(marquee);
      } else {
        startWhenReady();
      }
    });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      initMarquees(document);
      return;
    }

    runNonCritical(() => initMarquees(document), { timeout: 1800 });
  });

  // Theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      initMarquees(e.target);
    });
  }

})();




(function() {
  function refreshAfterpay(amountCents) {
    const el = document.querySelector('square-placement[data-amount]');
    if (!el) return;

    // Update the widget’s data-amount attribute
    el.setAttribute('data-amount', (amountCents / 100).toFixed(2));

    // Re-init Afterpay if possible
    if (window.Afterpay?.initialize) {
      window.Afterpay.initialize();
    } else if (window.Afterpay?.refresh) {
      window.Afterpay.refresh();
    } else if (window.Clearpay?.initialize) {
      window.Clearpay.initialize();
    }
  }

  function getCurrentVariantPrice() {
    const jsonEl = document.querySelector('variant-picker script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      const data = JSON.parse(jsonEl.textContent);
      return data?.price || null;
    } catch(e) {
      console.warn('Could not parse current variant JSON', e);
      return null;
    }
  }

  // Hook into your theme’s event
  window.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (variant) {
      refreshAfterpay(variant.price);
    }
  });

  // Fallback for direct clicks on radios
  document.addEventListener('change', (e) => {
    if (e.target.closest('.variant-picker')) {
      const price = getCurrentVariantPrice();
      if (price) refreshAfterpay(price);
    }
  });

  // Kick it once on load with the current variant price
  document.addEventListener('DOMContentLoaded', () => {
    const price = getCurrentVariantPrice();
    if (price) refreshAfterpay(price);
  });
})();






/***************** SKY VIDEO *****************/

let skyVideoLazyObserver = null;
let skyVideoFullscreenBound = false;

function isSkyVideoNearViewport(container) {
  const rect = container.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  return rect.top <= viewportHeight + 250 && rect.bottom >= -250;
}

function forceSkyVideoUIUpdate() {
  if (document.fullscreenElement || document.webkitFullscreenElement) return;

  document.querySelectorAll(".sky-video-container").forEach(container => {
    const playButton = container.querySelector(".sky-video-play-button");
    const muteButton = container.querySelector(".mute-btn");
    const progressBar = container.querySelector(".sky-progress-bar");
    const fullscreenButton = container.querySelector(".fullscreen-btn");

    const showMuteButton = container.dataset.showMute === "true";
    const showProgressBar = container.dataset.showProgress === "true";
    const showExpandButton = container.dataset.showExpand === "true";

    if (playButton) {
      playButton.style.display = "none";
      setTimeout(() => (playButton.style.display = "flex"), 50);
    }

    if (fullscreenButton) {
      fullscreenButton.style.display = "none";
      setTimeout(
        () => (fullscreenButton.style.display = showExpandButton ? "flex" : "none"),
        50
      );
    }

    if (muteButton) {
      muteButton.style.display = "none";
      setTimeout(
        () => (muteButton.style.display = showMuteButton ? "flex" : "none"),
        50
      );
    }

    if (progressBar) {
      progressBar.style.display = "none";
      setTimeout(
        () => (progressBar.style.display = showProgressBar ? "block" : "none"),
        50
      );
    }
  });
}

function ensureSkyVideoLazyObserver() {
  if (skyVideoLazyObserver || !('IntersectionObserver' in window)) {
    return skyVideoLazyObserver;
  }

  skyVideoLazyObserver = new IntersectionObserver((entries) => {
    let shouldInit = false;

    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      skyVideoLazyObserver.unobserve(entry.target);

      if (entry.target.dataset.initialized === "lazy") {
        entry.target.dataset.initialized = "";
        shouldInit = true;
      }
    });

    if (shouldInit) {
      runNonCritical(initSkyVideoSections, { timeout: 700, fallbackDelay: 0 });
    }
  }, { rootMargin: "250px 0px" });

  return skyVideoLazyObserver;
}

function initSkyVideoSections() {
  document.querySelectorAll(".sky-video-container").forEach(container => {
    if (container.dataset.initialized === "true" || container.dataset.initialized === "lazy") return;

    const autoplayEnabled = container.dataset.autoplay === "true";
    const isDesignMode = typeof Shopify !== "undefined" && Shopify.designMode;
    const shouldDelayInit = !isDesignMode && !autoplayEnabled && !isSkyVideoNearViewport(container);

    if (shouldDelayInit) {
      const observer = ensureSkyVideoLazyObserver();
      if (observer) {
        container.dataset.initialized = "lazy";
        observer.observe(container);
        return;
      }
    }

    container.dataset.initialized = "true";

    const video = container.querySelector(".sky-video");
    if (!video) return;

    const playButton        = container.querySelector(".sky-video-play-button");
    const muteButton        = container.querySelector(".mute-btn");
    const muteIcon          = muteButton ? muteButton.querySelector("i") : null;
    const progressBar       = container.querySelector(".sky-progress-bar");
    const progressIndicator = container.querySelector(".progress-indicator");
    const fullscreenButton  = container.querySelector(".fullscreen-btn");
    const canvas            = container.querySelector(".video-canvas");
    const ctx               = canvas ? canvas.getContext("2d") : null;

    const loopEnabled       = container.dataset.loop === "true";
    const showMuteButton    = container.dataset.showMute === "true";
    const muteVideo         = container.dataset.mute === "true";
    const showProgressBar   = container.dataset.showProgress === "true";
    const frameCaptureTime  = parseFloat(container.dataset.frameTime) || 1;
    const showExpandButton  = container.dataset.showExpand === "true";
    const videoDimensions   = container.dataset.videoDimensions;
    const preventToggle     = container.dataset.preventToggle === "true";

    // Loop support
    video.loop = loopEnabled;

    // "Original" aspect ratio mode
    if (videoDimensions === "original") {
      video.preload = "metadata";
      video.load();

      video.addEventListener("loadedmetadata", function () {
        let videoWidth = video.videoWidth;
        let videoHeight = video.videoHeight;

        if (videoWidth === 0 || videoHeight === 0) {
          setTimeout(() => {
            videoWidth = video.videoWidth;
            videoHeight = video.videoHeight;
            applyAspectRatio(videoWidth, videoHeight);
          }, 500);
        } else {
          applyAspectRatio(videoWidth, videoHeight);
        }
      });
    }

    video.addEventListener("play", () => {
      const placeholder = container.querySelector(".video-placeholder");
      if (placeholder) placeholder.style.display = "none";
    });

    function applyAspectRatio(width, height) {
      if (width > 0 && height > 0) {
        container.style.aspectRatio = width / height;
      }
    }

    // Fullscreen button visibility + single click handler
    if (!showExpandButton && fullscreenButton) {
      fullscreenButton.style.display = "none";
    } else if (fullscreenButton) {
      fullscreenButton.addEventListener("click", toggleFullscreen);
    }

    // Autoplay behavior
    if (autoplayEnabled) {
      video.setAttribute("autoplay", "true");
      video.muted = true;
      if (playButton) playButton.style.opacity = "0";
    } else {
      video.removeAttribute("autoplay");
    }

    // Hide mute UI if we're forcing mute with no button
    if (muteVideo && !showMuteButton && muteButton) {
      muteButton.style.display = "none";
    }

    function updateMuteIcon() {
      if (!muteIcon) return;
      muteIcon.classList.toggle("fa-volume", !video.muted);
      muteIcon.classList.toggle("fa-volume-slash", video.muted);
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
        if (playButton) playButton.style.opacity = "0";
      } else {
        video.pause();
        if (playButton) playButton.style.opacity = "1";
      }
    }

    function toggleMute() {
      video.muted = !video.muted;
      updateMuteIcon();
    }

    function updateProgressBar() {
      if (!progressIndicator || !video.duration) return;
      const progress = (video.currentTime / video.duration) * 100;
      progressIndicator.style.width = progress + "%";
    }

    function seekVideo(event) {
      if (!progressBar || !video.duration) return;
      const rect = progressBar.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const newTime = (offsetX / rect.width) * video.duration;
      video.currentTime = newTime;
    }

    let isDragging = false;

    function startDrag(event) {
      isDragging = true;
      seekVideo(event);
      document.addEventListener("mousemove", dragSeek);
      document.addEventListener("mouseup", stopDrag);
    }

    function dragSeek(event) {
      if (isDragging) {
        seekVideo(event);
      }
    }

    function stopDrag() {
      isDragging = false;
      document.removeEventListener("mousemove", dragSeek);
      document.removeEventListener("mouseup", stopDrag);
    }

    function toggleFullscreen() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        // Enter fullscreen
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          // iOS Safari
          video.webkitEnterFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    // Sync UI when fullscreen ends; bind once globally.
    if (!skyVideoFullscreenBound) {
      skyVideoFullscreenBound = true;
      document.addEventListener("fullscreenchange", forceSkyVideoUIUpdate);
      document.addEventListener("webkitfullscreenchange", forceSkyVideoUIUpdate);
    }

    const hasPoster = video.hasAttribute("poster") && video.getAttribute("poster") !== "";

    function captureFrame() {
      try {
        if (!ctx) return;

        if (video.src && video.src.startsWith("http") && new URL(video.src).origin !== location.origin) {
          console.warn("Skipping frame capture due to CORS restrictions.");
          return;
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.setAttribute("poster", canvas.toDataURL("image/webp"));
      } catch (error) {
        console.error("Failed to capture video frame:", error);
      }
    }

    if (!hasPoster && canvas) {
      video.addEventListener("loadedmetadata", function () {
        if (video.readyState >= 2) {
          video.currentTime = frameCaptureTime;
        } else {
          console.warn("Skipping seek due to video not being ready.");
        }
      });

      video.addEventListener("seeked", captureFrame);
    }

    // Autoplay + preventToggle: force playing, no toggling
    if (autoplayEnabled && preventToggle) {
      if (playButton) playButton.style.display = "none";
      video.addEventListener("play", () => (video.controls = false));
      video.addEventListener("pause", () => video.play());
    }

    // Click-to-play only when not explicitly prevented
    if (!autoplayEnabled || !preventToggle) {
      if (playButton) playButton.addEventListener("click", togglePlayPause);
      video.addEventListener("click", togglePlayPause);
    }

    video.addEventListener("ended", () => {
      if (playButton) playButton.style.opacity = "1";
    });

    if (muteButton) muteButton.addEventListener("click", toggleMute);

    video.addEventListener("timeupdate", updateProgressBar);
    video.addEventListener("play", updateProgressBar);
    video.addEventListener("seeked", updateProgressBar);

    if (progressBar)       progressBar.addEventListener("mousedown", startDrag);
    if (progressIndicator) progressIndicator.addEventListener("mousedown", startDrag);

    updateMuteIcon();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    initSkyVideoSections();
    return;
  }

  runNonCritical(initSkyVideoSections, { timeout: 1600 });
});

if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load",   initSkyVideoSections);
  document.addEventListener("shopify:section:unload", initSkyVideoSections);
}




/*************** COURSE MODULES INIT 

document.addEventListener("DOMContentLoaded", initCourseModules);
document.addEventListener("shopify:section:load", initCourseModules);

function initCourseModules() {
  // ACCORDION BEHAVIOUR
  document.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    const btn   = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        // Closing accordion: stop any videos inside
        btn.setAttribute('aria-expanded', 'false');

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v  = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = "1";
        });

        // Collapse
        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });

      } else {
        // Opening accordion
        btn.setAttribute('aria-expanded', 'true');

        // Expand
        panel.style.maxHeight = inner.scrollHeight + 'px';

        // Initialize videos that appear inside the accordion AFTER it's visible
        setTimeout(() => {
          if (typeof initSkyVideoSections === "function") {
            initSkyVideoSections();
          }
        }, 50);

        panel.addEventListener('transitionend', function handler() {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  // CHECKBOX PERSISTENCE
  document.querySelectorAll('.cm-item').forEach(item => {
    const section = item.closest('.cm-section');
    if (!section) return;

    const sectionId  = section.dataset.sectionId;
    const customerId = section.dataset.customerId || 'guest';
    const id         = item.dataset.blockId;

    if (!sectionId || !id) return;

    const key = `cm:${sectionId}:${id}:completed:${customerId}`;

    const box = item.querySelector('.cm-check-input');
    if (!box) return;

    if (localStorage.getItem(key) === '1') box.checked = true;

    box.addEventListener('change', () => {
      if (box.checked) localStorage.setItem(key, '1');
      else localStorage.removeItem(key);
    });
  });
}
***************/


/*************** COURSE MODULES INIT 

document.addEventListener('DOMContentLoaded', initCourseModules);
document.addEventListener('shopify:section:load', initCourseModules);

function initCourseModules(event) {
  const root = event && event.target ? event.target : document;

  // 1. Build collapsible groups from heading blocks
  initCourseModuleGroups(root);

  // 2. Accordion behaviour for module blocks
  initCourseModuleAccordions(root);

  // 3. Checkbox persistence
  initCourseModuleCheckboxes(root);
  initCourseModuleTabs(root);

}
*****/
/*************** HEADING GROUPS (FA PLUS/MINUS)

function initCourseModuleGroups(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    if (section.dataset.cmGroupsInit === 'true') return;
    section.dataset.cmGroupsInit = 'true';

    const list = section.querySelector('.cm-list');
    if (!list) return;

    const children = Array.from(list.children);
    const total = children.length;
    let i = 0;

    while (i < total) {
      const heading = children[i];

      if (!heading.classList.contains('cm-heading-block')) {
        i++;
        continue;
      }

      const collapsible = heading.dataset.collapsible === 'true';
      if (!collapsible) {
        i++;
        continue;
      }

      if (heading.dataset.cmGroupInit === 'true') {
        i++;
        continue;
      }
      heading.dataset.cmGroupInit = 'true';

      const openByDefault = heading.dataset.open === 'true';

      // CREATE GROUP WRAPPER
      const group = document.createElement('div');
      group.className = 'cm-group';

      // Toggle icon container
      const toggle = document.createElement('div');
      toggle.className = 'cm-heading-toggle';
      toggle.innerHTML = `
        <i class="fa-regular fa-plus cm-heading-toggle-icon"></i>
      `;
      heading.appendChild(toggle);

      // Insert group after heading
      if (heading.nextSibling) {
        list.insertBefore(group, heading.nextSibling);
      } else {
        list.appendChild(group);
      }

      // Move modules until next heading
      let j = i + 1;
      while (j < children.length) {
        const node = children[j];
        if (!node) {
          j++;
          continue;
        }
        if (node.classList.contains('cm-heading-block')) break;
        if (node.parentElement === list) group.appendChild(node);
        j++;
      }

      if (!group.children.length) {
        group.remove();
        i = j;
        continue;
      }

      // Initial state
      if (openByDefault) {
        heading.classList.add('is-open');
        group.style.maxHeight = 'none';
      } else {
        heading.classList.add('is-closed-border');
        group.style.maxHeight = '0px';
      }

      updateGroupToggleIcon(heading);

      // Click entire heading
      heading.addEventListener('click', e => {
        const isOpen = heading.classList.contains('is-open');

        if (isOpen) {
          // Close
          group.style.maxHeight = group.scrollHeight + 'px';
          requestAnimationFrame(() => {
            group.style.maxHeight = '0px';
          });
          heading.classList.remove('is-open');
          heading.classList.add('is-closed-border');
        } else {
          // Open
          group.style.maxHeight = group.scrollHeight + 'px';
          heading.classList.add('is-open');
          heading.classList.remove('is-closed-border');

          const handler = () => {
            if (heading.classList.contains('is-open')) {
              group.style.maxHeight = 'none';
            }
            group.removeEventListener('transitionend', handler);
          };
          group.addEventListener('transitionend', handler);
        }

        updateGroupToggleIcon(heading);
      });

      i = j;
    }
  });
}

function updateGroupToggleIcon(heading) {
  const icon = heading.querySelector('.cm-heading-toggle-icon');
  if (!icon) return;

  if (heading.classList.contains('is-open')) {
    icon.classList.remove('fa-plus');
    icon.classList.add('fa-minus');
  } else {
    icon.classList.remove('fa-minus');
    icon.classList.add('fa-plus');
  }
}
******/

/*************** MODULE ACCORDIONS

function initCourseModuleAccordions(root) {
  root.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    if (item.dataset.cmAccordionInit === 'true') return;
    item.dataset.cmAccordionInit = 'true';

    const btn = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    const section = item.closest('.cm-section');
    const sectionId = section ? (section.dataset.sectionId || section.id || '') : '';
    const customerId = section ? (section.dataset.customerId || 'guest') : 'guest';
    const blockId = item.dataset.blockId || '';
    const storageKey = getCourseModuleAccordionStorageKey(sectionId, blockId, customerId);
    const defaultExpanded = btn.getAttribute('aria-expanded') === 'true';
    const persistedExpanded = getCourseAccordionOpenFromLocal(storageKey);
    const initialExpanded = persistedExpanded === null ? defaultExpanded : persistedExpanded;

    btn.setAttribute('aria-expanded', initialExpanded ? 'true' : 'false');
    panel.style.maxHeight = initialExpanded ? 'none' : '0px';

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');
        setCourseAccordionOpenInLocal(storageKey, false);

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = '1';
        });

        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
      } else {
        btn.setAttribute('aria-expanded', 'true');

        panel.style.maxHeight = inner.scrollHeight + 'px';

        setTimeout(() => {
          if (typeof initSkyVideoSections === 'function') {
            initSkyVideoSections();
          }
        }, 50);

        const onTransitionEnd = () => {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', onTransitionEnd);
        };

        panel.addEventListener('transitionend', onTransitionEnd);
      }
    });
  });
}

*****/

/*************** CHECKBOX PERSISTENCE 
function initCourseModuleCheckboxes(root) {
  root.querySelectorAll('.cm-item').forEach(item => {
    if (item.dataset.cmCheckboxInit === 'true') return;
    item.dataset.cmCheckboxInit = 'true';

    const section = item.closest('.cm-section');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const customerId = section.dataset.customerId || 'guest';
    const id = item.dataset.blockId;

    if (!sectionId || !id) return;

    const key = `cm:${sectionId}:${id}:completed:${customerId}`;
    const box = item.querySelector('.cm-check-input');
    if (!box) return;

    if (localStorage.getItem(key) === '1') {
      box.checked = true;
    }

    box.addEventListener('change', () => {
      if (box.checked) {
        localStorage.setItem(key, '1');
      } else {
        localStorage.removeItem(key);
      }
    });
  });
}

****/

/*************** TAB FILTERING

function initCourseModuleTabs(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    if (section.dataset.cmTabsInit === 'true') return;
    section.dataset.cmTabsInit = 'true';

    const tabs = section.querySelectorAll('.cm-tab');
    const items = section.querySelectorAll('.cm-item');

    if (!tabs.length || !items.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        items.forEach(item => {
          const tabsAttr = item.dataset.tabs || '';

          if (selected === '__all__') {
            item.style.display = '';
            return;
          }

          const tabList = tabsAttr.split(',').filter(Boolean);

          if (tabList.includes(selected)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  });
}

****/



/*************** SUBSCRIPTION AGREEMENT ***************/

(function () {
  if (window.__subscriptionAgreementManagerInitialized) return;
  window.__subscriptionAgreementManagerInitialized = true;

  const agreements = new WeakMap();

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getContextRoot(agreement) {
    return agreement.closest('quick-buy-drawer, .product-info, product-rerender') || document;
  }

  function getPurchaseOptions(agreement) {
    const root = getContextRoot(agreement);
    let options = Array.from(root.querySelectorAll('input[name="purchaseOption"]'));

    if (!options.length) {
      options = Array.from(document.querySelectorAll('input[name="purchaseOption"]'));
    }

    return options;
  }

  function getBuyButtonWrappers(agreement, formId) {
    if (formId) {
      const selector = 'buy-buttons.buy-buttons[form="' + cssEscape(formId) + '"]';
      const scopedWrappers = Array.from(document.querySelectorAll(selector));

      if (scopedWrappers.length) {
        return scopedWrappers;
      }
    }

    return Array.from(getContextRoot(agreement).querySelectorAll('buy-buttons.buy-buttons'));
  }

  function updateAgreementState(agreement) {
    const checkbox = agreement.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    const formId = agreement.dataset.formId || checkbox.getAttribute('form') || '';
    const wrappers = getBuyButtonWrappers(agreement, formId);

    const subscriptionSelected = getPurchaseOptions(agreement).some((input) => {
      return input.value === 'subscription' && input.checked;
    });

    if (subscriptionSelected) {
      agreement.style.display = 'block';
      checkbox.required = true;
    } else {
      agreement.style.display = 'none';
      checkbox.required = false;
      checkbox.checked = false;
    }

    wrappers.forEach((wrapper) => {
      const submitButtons = wrapper.querySelectorAll('button[type="submit"]');
      const shouldDisable = subscriptionSelected && !checkbox.checked;

      wrapper.classList.toggle('is-disabled', shouldDisable);
      submitButtons.forEach((button) => {
        button.disabled = shouldDisable;
      });
    });
  }

  function wireAgreement(agreement) {
    let state = agreements.get(agreement);

    if (!state) {
      const checkbox = agreement.querySelector('input[type="checkbox"]');
      if (!checkbox) return;

      state = {
        update: function () {
          updateAgreementState(agreement);
        },
        boundInputs: new WeakSet()
      };

      checkbox.addEventListener('change', state.update);
      agreements.set(agreement, state);
    }

    getPurchaseOptions(agreement).forEach((input) => {
      if (!state.boundInputs.has(input)) {
        input.addEventListener('change', state.update);
        state.boundInputs.add(input);
      }
    });

    state.update();
  }

  function refreshAgreements() {
    document.querySelectorAll('[data-subscription-agreement]').forEach(wireAgreement);
  }

  let rafId = null;
  function scheduleRefresh() {
    if (rafId) return;

    rafId = requestAnimationFrame(function () {
      rafId = null;
      refreshAgreements();
    });
  }

  const observer = new MutationObserver(scheduleRefresh);
  runNonCritical(() => {
    observer.observe(document.body, { childList: true, subtree: true });
  }, { timeout: 2000 });

  refreshAgreements();
})();




/* ========================= COURSE MODULES JS START ========================= */
// COURSE MODULES INIT
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.cm-section')) return;
  runNonCritical(() => initCourseModules({ target: document }), { timeout: 1800 });
});
document.addEventListener('shopify:section:load', initCourseModules);

function initCourseModules(event) {
  const root = event && event.target ? event.target : document;

  initCourseSectionAccordions(root);
  initCourseModuleGroups(root);
  initCourseModuleAccordions(root);
  initCourseModuleCheckboxes(root);
  initCourseModuleTabs(root);
  initCourseProgressSections({ target: root });
  refreshAllCourseProgressBars(false);
}

function hasLinkedCourseNavigation(section) {
  if (!section) return false;
  const courseId = normalizeCourseKey(section.dataset.courseId);
  if (!courseId) return false;
  return !!document.querySelector(`.cm-nav[data-course-id="${courseId}"]`);
}

function getCourseSectionAccordionStorageKey(sectionId, customerId) {
  if (!sectionId) return '';
  return `cm:${sectionId}:section-open:${customerId || 'guest'}`;
}

function getCourseModuleAccordionStorageKey(sectionId, blockId, customerId) {
  if (!sectionId || !blockId) return '';
  return `cm:${sectionId}:${blockId}:accordion-open:${customerId || 'guest'}`;
}

function getCourseAccordionOpenFromLocal(storageKey) {
  if (!storageKey) return null;
  try {
    const value = localStorage.getItem(storageKey);
    if (value === null) return null;
    return value === '1';
  } catch (err) {
    return null;
  }
}

function setCourseAccordionOpenInLocal(storageKey, isOpen) {
  if (!storageKey) return;
  try {
    localStorage.setItem(storageKey, isOpen ? '1' : '0');
  } catch (err) {
    // Ignore storage failures and keep current UI state.
  }
}

function initCourseSectionAccordions(root) {
  root.querySelectorAll('.cm-section[data-cm-section-collapsible="true"]').forEach(section => {
    if (section.dataset.cmSectionAccordionInit === 'true') return;
    section.dataset.cmSectionAccordionInit = 'true';

    const toggle = section.querySelector('[data-cm-section-toggle]');
    const content = section.querySelector('[data-cm-section-content]');
    if (!toggle || !content) return;

    const openByDefault = section.dataset.cmSectionOpen !== 'false';
    const showClosedBorder = section.dataset.cmSectionClosedBorder === 'true';
    const sectionId = section.dataset.sectionId || section.id || '';
    const customerId = section.dataset.customerId || 'guest';
    const storageKey = getCourseSectionAccordionStorageKey(sectionId, customerId);
    const persistedOpen = getCourseAccordionOpenFromLocal(storageKey);
    const initialOpen = persistedOpen === null ? openByDefault : persistedOpen;
    const setOpen = (nextOpen, animate = true, persist = true) => {
      const isOpen = toggle.classList.contains('is-open');
      if (isOpen === nextOpen) return;

      if (nextOpen) {
        const targetHeight = content.scrollHeight;
        if (animate) {
          content.style.maxHeight = `${targetHeight}px`;
          const onTransitionEnd = () => {
            if (toggle.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', onTransitionEnd);
          };
          content.addEventListener('transitionend', onTransitionEnd);
        } else {
          content.style.maxHeight = 'none';
        }

        toggle.classList.add('is-open');
        toggle.classList.remove('is-closed-border');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        if (animate) {
          content.style.maxHeight = `${content.scrollHeight}px`;
          requestAnimationFrame(() => {
            content.style.maxHeight = '0px';
          });
        } else {
          content.style.maxHeight = '0px';
        }

        toggle.classList.remove('is-open');
        toggle.classList.toggle('is-closed-border', showClosedBorder);
        toggle.setAttribute('aria-expanded', 'false');
      }

      updateGroupToggleIcon(toggle);
      if (persist) {
        setCourseAccordionOpenInLocal(storageKey, nextOpen);
      }
    };

    toggle.classList.toggle('is-open', initialOpen);
    toggle.classList.toggle('is-closed-border', showClosedBorder && !initialOpen);
    toggle.setAttribute('aria-expanded', initialOpen ? 'true' : 'false');
    content.style.maxHeight = initialOpen ? 'none' : '0px';
    updateGroupToggleIcon(toggle);

    section._cmSectionAccordion = {
      setOpen,
      isOpen: () => toggle.classList.contains('is-open')
    };

    toggle.addEventListener('click', () => {
      const isOpen = toggle.classList.contains('is-open');
      setOpen(!isOpen, true);
    });
  });
}

function initCourseModuleGroups(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    // In navigation-managed mode, keep headings collapsible without structural wrappers.
    if (hasLinkedCourseNavigation(section)) {
      initCourseModuleManagedHeadingToggles(section);
      return;
    }
    if (section.dataset.cmGroupsInit === 'true') return;
    section.dataset.cmGroupsInit = 'true';

    const list = section.querySelector('.cm-list');
    if (!list) return;

    const children = Array.from(list.children);
    const total = children.length;
    let i = 0;

    while (i < total) {
      const heading = children[i];

      if (!heading.classList.contains('cm-heading-block')) {
        i++;
        continue;
      }

      const collapsible = heading.dataset.collapsible === 'true';
      if (!collapsible) {
        i++;
        continue;
      }

      if (heading.dataset.cmGroupInit === 'true') {
        i++;
        continue;
      }
      heading.dataset.cmGroupInit = 'true';

      const openByDefault = heading.dataset.open === 'true';

      const group = document.createElement('div');
      group.className = 'cm-group';

      const toggle = document.createElement('div');
      toggle.className = 'cm-heading-toggle';
      toggle.innerHTML = '<i class="fa-regular fa-plus cm-heading-toggle-icon"></i>';
      heading.appendChild(toggle);

      if (heading.nextSibling) {
        list.insertBefore(group, heading.nextSibling);
      } else {
        list.appendChild(group);
      }

      let j = i + 1;
      while (j < children.length) {
        const node = children[j];
        if (!node) {
          j++;
          continue;
        }
        if (node.classList.contains('cm-heading-block')) break;
        if (node.parentElement === list) group.appendChild(node);
        j++;
      }

      if (!group.children.length) {
        group.remove();
        i = j;
        continue;
      }

      if (openByDefault) {
        heading.classList.add('is-open');
        group.style.maxHeight = 'none';
      } else {
        heading.classList.add('is-closed-border');
        group.style.maxHeight = '0px';
      }

      updateGroupToggleIcon(heading);

      heading.addEventListener('click', () => {
        const isOpen = heading.classList.contains('is-open');

        if (isOpen) {
          group.style.maxHeight = group.scrollHeight + 'px';
          requestAnimationFrame(() => {
            group.style.maxHeight = '0px';
          });
          heading.classList.remove('is-open');
          heading.classList.add('is-closed-border');
        } else {
          group.style.maxHeight = group.scrollHeight + 'px';
          heading.classList.add('is-open');
          heading.classList.remove('is-closed-border');

          const handler = () => {
            if (heading.classList.contains('is-open')) {
              group.style.maxHeight = 'none';
            }
            group.removeEventListener('transitionend', handler);
          };
          group.addEventListener('transitionend', handler);
        }

        updateGroupToggleIcon(heading);
      });

      i = j;
    }
  });
}

function initCourseModuleManagedHeadingToggles(section) {
  if (!section) return;

  const list = section.querySelector('.cm-list');
  if (!list) return;

  // If wrappers were created before nav was added, flatten them.
  Array.from(list.children).forEach(node => {
    if (!node.classList || !node.classList.contains('cm-group')) return;
    while (node.firstChild) {
      list.insertBefore(node.firstChild, node);
    }
    node.remove();
  });

  const headings = Array.from(section.querySelectorAll('.cm-heading-block'));
  headings.forEach(originalHeading => {
    let heading = originalHeading;
    const shouldRebind = heading.dataset.cmGroupInit === 'true' || heading.dataset.cmManagedHeadingBound === 'true';
    if (shouldRebind) {
      const clone = heading.cloneNode(true);
      heading.replaceWith(clone);
      heading = clone;
    }

    const collapsible = heading.dataset.collapsible === 'true';
    if (!collapsible) return;

    const headingIndex = heading.dataset.headingIndex;
    if (!headingIndex) return;

    const existingToggle = heading.querySelector('.cm-heading-toggle');
    if (existingToggle) existingToggle.remove();

    const toggle = document.createElement('div');
    toggle.className = 'cm-heading-toggle';
    toggle.innerHTML = '<i class="fa-regular fa-plus cm-heading-toggle-icon"></i>';
    heading.appendChild(toggle);

    const openByDefault = heading.dataset.open === 'true';
    const collapsed = heading.dataset.cmCollapsedByHeading === 'true'
      ? true
      : !openByDefault;

    heading.classList.toggle('is-open', !collapsed);
    heading.classList.toggle('is-closed-border', collapsed);
    setManagedHeadingItemsCollapsed(section, headingIndex, collapsed, false);
    updateGroupToggleIcon(heading);

    heading.dataset.cmManagedHeadingBound = 'true';
    heading.addEventListener('click', () => {
      const isOpen = heading.classList.contains('is-open');
      const nextCollapsed = isOpen;

      heading.classList.toggle('is-open', !nextCollapsed);
      heading.classList.toggle('is-closed-border', nextCollapsed);
      heading.dataset.cmCollapsedByHeading = nextCollapsed ? 'true' : 'false';

      setManagedHeadingItemsCollapsed(section, headingIndex, nextCollapsed, true);
      updateGroupToggleIcon(heading);
    });
  });
}

function setManagedHeadingItemsCollapsed(section, headingIndex, collapsed, animate) {
  section.querySelectorAll(`.cm-item[data-heading-index="${headingIndex}"]`).forEach(item => {
    item.dataset.cmCollapsedByHeading = collapsed ? 'true' : 'false';

    if (!animate) {
      item.hidden = collapsed;
      if (collapsed) item.setAttribute('aria-hidden', 'true');
      else item.removeAttribute('aria-hidden');
      if (!collapsed) item.style.removeProperty('display');
      item.style.display = collapsed ? 'none' : '';
      resetManagedHeadingItemStyles(item);
      return;
    }

    if (collapsed) {
      collapseManagedHeadingItem(item);
    } else {
      expandManagedHeadingItem(item);
    }
  });
}

function resetManagedHeadingItemStyles(item) {
  item.style.removeProperty('transition');
  item.style.removeProperty('overflow');
  item.style.removeProperty('max-height');
  item.style.removeProperty('opacity');
}

function finishManagedHeadingItemAnimation(item, onFinish) {
  if (item._cmHeadingAnimCleanup) item._cmHeadingAnimCleanup();

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    item.removeEventListener('transitionend', onEnd);
    item._cmHeadingAnimCleanup = null;
  };

  const onEnd = e => {
    if (e.target !== item || e.propertyName !== 'max-height') return;
    cleanup();
    if (typeof onFinish === 'function') onFinish();
  };

  item._cmHeadingAnimCleanup = cleanup;
  item.addEventListener('transitionend', onEnd);
}

function collapseManagedHeadingItem(item) {
  if (item.hidden || item.style.display === 'none') {
    item.hidden = true;
    item.setAttribute('aria-hidden', 'true');
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.hidden = false;
  item.removeAttribute('aria-hidden');
  item.style.removeProperty('display');
  item.style.display = '';

  const startHeight = item.scrollHeight;
  if (startHeight <= 0) {
    item.hidden = true;
    item.setAttribute('aria-hidden', 'true');
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.style.overflow = 'hidden';
  item.style.maxHeight = `${startHeight}px`;
  item.style.opacity = '1';
  item.style.transition = 'none';

  // Force layout so browser has a concrete starting point before animating.
  void item.offsetHeight;

  item.style.transition = 'max-height .35s ease, opacity .25s ease';

  requestAnimationFrame(() => {
    item.style.maxHeight = '0px';
    item.style.opacity = '0';
  });

  finishManagedHeadingItemAnimation(item, () => {
    item.hidden = true;
    item.setAttribute('aria-hidden', 'true');
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
  });
}

function expandManagedHeadingItem(item) {
  item.hidden = false;
  item.removeAttribute('aria-hidden');
  item.style.removeProperty('display');
  item.style.display = '';
  const endHeight = item.scrollHeight;

  if (endHeight <= 0) {
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.style.overflow = 'hidden';
  item.style.maxHeight = '0px';
  item.style.opacity = '0';
  item.style.transition = 'none';

  // Force layout so the 0px start state is committed before opening.
  void item.offsetHeight;

  item.style.transition = 'max-height .35s ease, opacity .25s ease';

  requestAnimationFrame(() => {
    item.style.maxHeight = `${endHeight}px`;
    item.style.opacity = '1';
  });

  finishManagedHeadingItemAnimation(item, () => {
    resetManagedHeadingItemStyles(item);
  });
}

function updateGroupToggleIcon(heading) {
  const icon = heading.querySelector('.cm-heading-toggle-icon');
  if (!icon) return;

  if (heading.classList.contains('is-open')) {
    icon.classList.remove('fa-plus');
    icon.classList.add('fa-minus');
  } else {
    icon.classList.remove('fa-minus');
    icon.classList.add('fa-plus');
  }
}

function initCourseModuleAccordions(root) {
  root.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    if (item.dataset.cmAccordionInit === 'true') return;
    item.dataset.cmAccordionInit = 'true';

    const btn = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    const section = item.closest('.cm-section');
    const sectionId = section ? (section.dataset.sectionId || section.id || '') : '';
    const customerId = section ? (section.dataset.customerId || 'guest') : 'guest';
    const blockId = item.dataset.blockId || '';
    const storageKey = getCourseModuleAccordionStorageKey(sectionId, blockId, customerId);
    const defaultExpanded = btn.getAttribute('aria-expanded') === 'true';
    const persistedExpanded = getCourseAccordionOpenFromLocal(storageKey);
    const initialExpanded = persistedExpanded === null ? defaultExpanded : persistedExpanded;

    btn.setAttribute('aria-expanded', initialExpanded ? 'true' : 'false');
    panel.style.maxHeight = initialExpanded ? 'none' : '0px';

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');
        setCourseAccordionOpenInLocal(storageKey, false);

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = '1';
        });

        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
      } else {
        btn.setAttribute('aria-expanded', 'true');
        setCourseAccordionOpenInLocal(storageKey, true);
        panel.style.maxHeight = inner.scrollHeight + 'px';

        setTimeout(() => {
          if (typeof initSkyVideoSections === 'function') {
            initSkyVideoSections();
          }
        }, 50);

        const onTransitionEnd = () => {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', onTransitionEnd);
        };

        panel.addEventListener('transitionend', onTransitionEnd);
      }
    });
  });
}

const cmProgressHydrationPromises = new Map();
const cmProgressWriteTimers = new Map();

function getCourseProgressStorageKey(sectionId, blockId, customerId) {
  return `cm:${sectionId}:${blockId}:completed:${customerId}`;
}

function getCourseProgressFromLocal(storageKey) {
  if (!storageKey) return false;
  try {
    return localStorage.getItem(storageKey) === '1';
  } catch (err) {
    return false;
  }
}

function setCourseProgressInLocal(storageKey, completed) {
  if (!storageKey) return;
  try {
    if (completed) {
      localStorage.setItem(storageKey, '1');
    } else {
      localStorage.removeItem(storageKey);
    }
  } catch (err) {
    // Ignore storage failures and continue with in-memory checkbox state.
  }
}

function getCourseProgressEndpoint(section) {
  if (!section) return '';
  const raw = String(section.dataset.progressEndpoint || '').trim();
  if (!raw) return '';
  return raw.startsWith('/') ? raw : `/${raw}`;
}

function shouldSyncCourseProgress(section, customerId) {
  if (!section) return false;
  if (section.dataset.progressPersist !== 'true') return false;
  if (!customerId || customerId === 'guest') return false;
  return getCourseProgressEndpoint(section) !== '';
}

function toCompletedBoolean(value) {
  if (value === true || value === 1 || value === '1') return true;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === 'yes';
  }
  return false;
}

function mapCourseProgressPayload(payload, sectionId) {
  const byBlockId = new Map();
  if (!payload || typeof payload !== 'object') return byBlockId;

  const progress = payload.progress;
  if (progress && typeof progress === 'object' && !Array.isArray(progress)) {
    Object.entries(progress).forEach(([key, value]) => {
      if (!key) return;
      const safeKey = String(key).trim();
      if (!safeKey) return;

      if (safeKey.includes(':')) {
        const parts = safeKey.split(':');
        if (parts.length !== 2) return;
        if (parts[0] !== sectionId) return;
        byBlockId.set(parts[1], toCompletedBoolean(value));
        return;
      }

      byBlockId.set(safeKey, toCompletedBoolean(value));
    });
  }

  const items = Array.isArray(payload.items) ? payload.items : [];
  items.forEach(item => {
    if (!item || typeof item !== 'object') return;
    const itemSectionId = String(item.section_id || item.sectionId || '').trim();
    if (itemSectionId && itemSectionId !== sectionId) return;
    const blockId = String(item.block_id || item.blockId || '').trim();
    if (!blockId) return;
    byBlockId.set(blockId, toCompletedBoolean(item.completed));
  });

  const completedIds = Array.isArray(payload.completed_block_ids)
    ? payload.completed_block_ids
    : (Array.isArray(payload.completedBlockIds) ? payload.completedBlockIds : []);
  completedIds.forEach(blockId => {
    const key = String(blockId || '').trim();
    if (!key) return;
    byBlockId.set(key, true);
  });

  return byBlockId;
}

// Expected app proxy GET response can include:
// { progress: { "<blockId>": true } } or { progress: { "<sectionId>:<blockId>": true } }
// { items: [{ section_id, block_id, completed }] } or { completed_block_ids: ["<blockId>"] }
function hydrateCourseProgressFromAccount(syncContext) {
  if (!syncContext) return;

  const { endpoint, customerId, courseId, sectionId, entries } = syncContext;
  if (!endpoint || !customerId || !courseId || !sectionId || !entries.length) return;

  const hydrateKey = `${endpoint}|${customerId}|${courseId}|${sectionId}`;
  if (cmProgressHydrationPromises.has(hydrateKey)) return;

  let url;
  try {
    url = new URL(endpoint, window.location.origin);
  } catch (err) {
    return;
  }

  url.searchParams.set('course_id', courseId);
  url.searchParams.set('section_id', sectionId);

  const request = fetch(url.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(response => {
      if (!response.ok) throw new Error(`Progress hydrate failed: ${response.status}`);
      return response.json();
    })
    .then(payload => {
      const completedByBlockId = mapCourseProgressPayload(payload, sectionId);
      if (!completedByBlockId.size) return;

      entries.forEach(entry => {
        if (!completedByBlockId.has(entry.blockId)) return;
        const completed = completedByBlockId.get(entry.blockId) === true;
        entry.box.checked = completed;
        setCourseProgressInLocal(entry.storageKey, completed);
      });

      refreshAllCourseNavigation(true);
      refreshAllCourseProgressBars(true);
    })
    .catch(() => {
      // Fallback remains localStorage-only if sync endpoint is unavailable.
    })
    .finally(() => {
      cmProgressHydrationPromises.delete(hydrateKey);
    });

  cmProgressHydrationPromises.set(hydrateKey, request);
}

function queueCourseProgressAccountSync(syncContext, entry, completed) {
  if (!syncContext || !entry) return;

  const { endpoint, customerId, courseId, sectionId } = syncContext;
  if (!endpoint || !customerId || !courseId || !sectionId) return;

  const writeKey = `${endpoint}|${customerId}|${courseId}|${sectionId}|${entry.blockId}`;
  if (cmProgressWriteTimers.has(writeKey)) {
    clearTimeout(cmProgressWriteTimers.get(writeKey));
  }

  const timer = setTimeout(() => {
    cmProgressWriteTimers.delete(writeKey);
    // POST payload expected by the app proxy for persistence.
    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        customer_id: customerId,
        course_id: courseId,
        section_id: sectionId,
        block_id: entry.blockId,
        completed: completed
      })
    }).catch(() => {
      // Keep local state even if remote sync fails.
    });
  }, 200);

  cmProgressWriteTimers.set(writeKey, timer);
}

function initCourseModuleCheckboxes(root) {
  root.querySelectorAll('.cm-section').forEach((section, sectionIndex) => {
    const sectionId = section.dataset.sectionId || section.id || `cm-${sectionIndex}`;
    const customerId = section.dataset.customerId || 'guest';
    const courseId = normalizeCourseKey(section.dataset.courseId || sectionId) || sectionId;
    const shouldSync = shouldSyncCourseProgress(section, customerId);
    const endpoint = shouldSync ? getCourseProgressEndpoint(section) : '';

    const syncContext = shouldSync
      ? { endpoint, customerId, courseId, sectionId, entries: [] }
      : null;

    section.querySelectorAll('.cm-item').forEach(item => {
      if (item.dataset.cmCheckboxInit === 'true') return;
      item.dataset.cmCheckboxInit = 'true';

      const blockId = item.dataset.blockId;
      if (!blockId) return;

      const storageKey = getCourseProgressStorageKey(sectionId, blockId, customerId);
      const box = item.querySelector('.cm-check-input');
      if (!box) return;

      box.checked = getCourseProgressFromLocal(storageKey);

      const entry = { blockId, storageKey, box };
      if (syncContext) syncContext.entries.push(entry);

      box.addEventListener('change', () => {
        const completed = box.checked;
        setCourseProgressInLocal(storageKey, completed);
        if (syncContext) {
          queueCourseProgressAccountSync(syncContext, entry, completed);
        }
        refreshAllCourseProgressBars(true);
      });
    });

    if (syncContext && syncContext.entries.length) {
      hydrateCourseProgressFromAccount(syncContext);
    }
  });
}

function initCourseModuleTabs(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    // Avoid overlap with course-sorting tabs/search/sort controls.
    if (hasLinkedCourseNavigation(section)) {
      const localTabs = section.querySelector('.cm-tabs');
      if (localTabs) localTabs.hidden = true;
      return;
    }
    if (section.dataset.cmTabsInit === 'true') return;
    section.dataset.cmTabsInit = 'true';

    const tabs = section.querySelectorAll('.cm-tab');
    const items = section.querySelectorAll('.cm-item');

    if (!tabs.length || !items.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        items.forEach(item => {
          const tabsAttr = item.dataset.tabs || '';

          if (selected === '__all__') {
            item.style.display = '';
            return;
          }

          const tabList = tabsAttr.split(',').map(value => value.trim()).filter(Boolean);

          if (tabList.includes(selected)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  });
}
/* ========================== COURSE MODULES JS END ========================== */

/* ========================= COURSE PROGRESS JS START ======================== */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-cm-progress]')) return;
  runNonCritical(() => initCourseProgressSections({ target: document }), { timeout: 1800 });
});
document.addEventListener('shopify:section:load', initCourseProgressSections);

let cmProgressGlobalBound = false;

function initCourseProgressSections(event) {
  const root = event && event.target ? event.target : document;
  if (!root || !root.querySelectorAll) return;

  root.querySelectorAll('[data-cm-progress]').forEach(section => {
    if (section.dataset.cmProgressInit !== 'true') {
      section.dataset.cmProgressInit = 'true';
    }
    refreshCourseProgressSection(section, false);
  });

  if (!cmProgressGlobalBound) {
    cmProgressGlobalBound = true;
    document.addEventListener('change', e => {
      const target = e.target;
      if (!target || !target.classList || !target.classList.contains('cm-check-input')) return;
      refreshAllCourseProgressBars(true);
    });
  }
}

function refreshAllCourseProgressBars(animate) {
  document.querySelectorAll('[data-cm-progress]').forEach(section => {
    refreshCourseProgressSection(section, animate === true);
  });
}

function getCourseProgressSourceSections(progressSection) {
  const allSections = Array.from(document.querySelectorAll('.cm-section[data-course-id]'));
  if (!allSections.length) return [];

  const scope = String(progressSection.dataset.courseScope || 'matching').trim();
  if (scope === 'all') return allSections;

  const courseId = normalizeCourseKey(progressSection.dataset.courseId || '');
  if (!courseId) return allSections;

  return allSections.filter(section => normalizeCourseKey(section.dataset.courseId || '') === courseId);
}

function escapeCourseProgressText(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildCourseProgressStats(progressSection) {
  const sourceSections = getCourseProgressSourceSections(progressSection);
  const breakdown = [];
  let total = 0;
  let completed = 0;

  sourceSections.forEach((section, index) => {
    const checkboxes = Array.from(section.querySelectorAll('.cm-check-input')).filter(box => !box.disabled);
    if (!checkboxes.length) return;

    const sectionTotal = checkboxes.length;
    const sectionCompleted = checkboxes.reduce((sum, box) => sum + (box.checked ? 1 : 0), 0);
    const sectionPercent = Math.round((sectionCompleted / sectionTotal) * 100);
    const sectionId = section.dataset.sectionId || section.id || `section-${index + 1}`;
    const fallbackTitle = `Section ${breakdown.length + 1}`;
    const title = String(section.dataset.sectionTitle || '').trim() || fallbackTitle;

    total += sectionTotal;
    completed += sectionCompleted;

    breakdown.push({
      id: sectionId,
      title: title,
      total: sectionTotal,
      completed: sectionCompleted,
      percent: sectionPercent
    });
  });

  return {
    total,
    completed,
    percent: total > 0 ? Math.round((completed / total) * 100) : 0,
    breakdown
  };
}

function refreshCourseProgressSection(progressSection, animate) {
  if (!progressSection) return;

  const summaryEl = progressSection.querySelector('[data-cm-progress-summary]');
  const trackedEl = progressSection.querySelector('[data-cm-progress-tracked]');
  const valueEl = progressSection.querySelector('[data-cm-progress-value]');
  const meterEl = progressSection.querySelector('[data-cm-progress-meter]');
  const fillEl = progressSection.querySelector('[data-cm-progress-fill]');
  const emptyEl = progressSection.querySelector('[data-cm-progress-empty]');
  const breakdownEl = progressSection.querySelector('[data-cm-progress-breakdown]');
  const cardEl = progressSection.querySelector('[data-cm-progress-card]');

  const summaryLabel = String(progressSection.dataset.summaryLabel || 'modules complete').trim();
  const trackLabel = String(progressSection.dataset.trackLabel || 'modules tracked').trim();
  const emptyMessage = String(progressSection.dataset.emptyMessage || 'No trackable modules were found.').trim();
  const showBreakdown = progressSection.dataset.showBreakdown === 'true';
  const stats = buildCourseProgressStats(progressSection);

  if (valueEl) valueEl.textContent = `${stats.percent}%`;
  if (summaryEl) summaryEl.textContent = `${stats.completed} of ${stats.total} ${summaryLabel}`;
  if (trackedEl) trackedEl.textContent = `${stats.total} ${trackLabel}`;

  if (meterEl) {
    meterEl.setAttribute('aria-valuenow', String(stats.percent));
    meterEl.setAttribute('aria-valuetext', `${stats.percent}% complete`);
  }

  if (fillEl) {
    if (!animate) {
      fillEl.style.transition = 'none';
      fillEl.style.width = `${stats.percent}%`;
      requestAnimationFrame(() => {
        fillEl.style.removeProperty('transition');
      });
    } else {
      fillEl.style.width = `${stats.percent}%`;
    }
  }

  if (cardEl) {
    cardEl.classList.toggle('is-complete', stats.total > 0 && stats.percent === 100);
  }

  if (emptyEl) {
    if (stats.total > 0) {
      emptyEl.hidden = true;
    } else {
      emptyEl.textContent = emptyMessage;
      emptyEl.hidden = false;
    }
  }

  if (breakdownEl) {
    if (!showBreakdown || !stats.breakdown.length) {
      breakdownEl.hidden = true;
      breakdownEl.innerHTML = '';
      return;
    }

    breakdownEl.hidden = false;
    breakdownEl.innerHTML = stats.breakdown.map(item => {
      return `
        <div class="cm-progress__row" data-cm-progress-row-id="${escapeCourseProgressText(item.id)}">
          <div class="cm-progress__row-top">
            <span class="cm-progress__row-title">${escapeCourseProgressText(item.title)}</span>
            <span class="cm-progress__row-pct">${item.percent}%</span>
          </div>
          <div class="cm-progress__row-track">
            <span class="cm-progress__row-fill" style="width:${item.percent}%"></span>
          </div>
          <div class="cm-progress__row-meta">${item.completed} of ${item.total}</div>
        </div>
      `;
    }).join('');
  }
}
/* ========================== COURSE PROGRESS JS END ========================= */

/* ======================== COURSE NAVIGATION JS START ======================== */
// COURSE NAVIGATION INIT
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.cm-nav')) return;
  runNonCritical(initCourseNavigation, { timeout: 1800 });
});
document.addEventListener('shopify:section:load', initCourseNavigation);

let cmNavGlobalBound = false;

function refreshAllCourseNavigation(forceSort) {
  document.querySelectorAll('.cm-nav').forEach(nav => {
    if (nav._cmNavState && typeof nav._cmNavState.refresh === 'function') {
      nav._cmNavState.refresh(forceSort === true);
    }
  });
}

function normalizeCourseKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function debounceCourseNav(fn, wait) {
  let timeout;
  return function() {
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

function setCourseNavVisibility(el, isVisible) {
  if (!el) return;
  el.hidden = !isVisible;
  if (isVisible) {
    el.style.removeProperty('display');
    el.removeAttribute('aria-hidden');
    return;
  }
  el.style.setProperty('display', 'none', 'important');
  el.setAttribute('aria-hidden', 'true');
}

function readCourseNavCustomTabs(nav) {
  const nodes = Array.from(nav.querySelectorAll('[data-cm-custom-tab]'));
  const seen = new Set();

  return nodes.map((node, index) => {
    const rawId = node.dataset.tabId || '';
    const key = normalizeCourseKey(rawId);
    if (!key || seen.has(key)) return null;
    seen.add(key);

    const rawLabel = String(node.dataset.tabLabel || rawId || key).trim();
    return {
      key: key,
      label: rawLabel || key,
      order: index
    };
  }).filter(Boolean);
}

function syncSearchSectionAccordionState(section, queryActive, shouldOpenForSearch) {
  if (!section || section.dataset.cmSectionCollapsible !== 'true') return;

  const accordion = section._cmSectionAccordion;
  if (!accordion || typeof accordion.setOpen !== 'function' || typeof accordion.isOpen !== 'function') return;

  if (queryActive && shouldOpenForSearch) {
    if (section.dataset.cmSearchAccordionManaged !== 'true') {
      section.dataset.cmSearchAccordionManaged = 'true';
      section.dataset.cmSearchAccordionPrevOpen = accordion.isOpen() ? 'true' : 'false';
    }
    accordion.setOpen(true, true, false);
    return;
  }

  if (!queryActive && section.dataset.cmSearchAccordionManaged === 'true') {
    const prevOpen = section.dataset.cmSearchAccordionPrevOpen === 'true';
    accordion.setOpen(prevOpen, true, false);
    section.removeAttribute('data-cm-search-accordion-managed');
    section.removeAttribute('data-cm-search-accordion-prev-open');
  }
}

function initCourseNavigation() {
  const navs = document.querySelectorAll('.cm-nav');
  if (!navs.length) return;

  if (!cmNavGlobalBound) {
    cmNavGlobalBound = true;
    document.addEventListener('change', e => {
      const target = e.target;
      if (!target || !target.classList || !target.classList.contains('cm-check-input')) return;
      refreshAllCourseNavigation(true);
    });
  }

  navs.forEach(nav => {
    if (nav._cmNavState) {
      nav._cmNavState.rebuild();
      nav._cmNavState.refresh(true);
      return;
    }
    nav._cmNavState = buildCourseNavState(nav);
  });
}

function buildCourseNavState(nav) {
  const elements = {
    tabs: nav.querySelector('[data-cm-tabs]'),
    search: nav.querySelector('[data-cm-search]'),
    clear: nav.querySelector('[data-cm-clear]'),
    sort: nav.querySelector('[data-cm-sort]'),
    meta: nav.querySelector('[data-cm-meta]'),
    empty: nav.querySelector('[data-cm-empty]')
  };

  const settings = {
    showTabs: nav.dataset.showTabs !== 'false',
    showAllTab: nav.dataset.showAll !== 'false',
    reverseTabOrder: nav.dataset.reverseTabOrder === 'true',
    doNotAutoSelectAll: nav.dataset.doNotAutoSelectAll === 'true',
    showCounts: nav.dataset.showCounts !== 'false',
    defaultTab: nav.dataset.defaultTab || 'all',
    defaultSort: nav.dataset.defaultSort || 'default',
    allLabel: nav.dataset.allLabel || 'All',
    emptyMessage: nav.dataset.emptyMessage || 'No modules match your search.',
    noSectionsMessage: nav.dataset.noSectionsMessage || 'Add a Course modules section with the same Course ID to connect.'
  };

  let sectionStates = [];
  let customTabs = [];
  let tiers = [];
  let useCustomTabs = false;
  let activeTierKey = 'all';
  let lastSortKey = null;

  const tabButtons = new Map();
  const tabCounts = new Map();

  function getDisplayTiers() {
    return settings.reverseTabOrder ? tiers.slice().reverse() : tiers.slice();
  }

  function rebuild() {
    const courseId = normalizeCourseKey(nav.dataset.courseId);
    if (!courseId) {
      if (elements.empty) {
        elements.empty.textContent = settings.noSectionsMessage;
        elements.empty.hidden = false;
      }
      if (elements.tabs) elements.tabs.hidden = true;
      return;
    }

    sectionStates = buildCourseSectionStates(courseId);
    customTabs = readCourseNavCustomTabs(nav);
    useCustomTabs = customTabs.length > 0;
    tiers = useCustomTabs ? buildCustomTabGroups(customTabs) : buildTierGroups(sectionStates);

    if (!sectionStates.length) {
      if (elements.empty) {
        elements.empty.textContent = settings.noSectionsMessage;
        elements.empty.hidden = false;
      }
      if (elements.tabs) elements.tabs.hidden = true;
      return;
    }

    if (elements.empty) elements.empty.hidden = true;

    if (settings.showTabs && elements.tabs && tiers.length) {
      renderTabs();
    } else if (elements.tabs) {
      elements.tabs.hidden = true;
    }

    const tierKeys = tiers.map(tier => tier.key);
    if (!tierKeys.includes(activeTierKey)) {
      const displayTiers = getDisplayTiers();
      if (settings.defaultTab === 'none') {
        activeTierKey = '__none__';
      } else if (settings.defaultTab === 'first' && displayTiers[0]) {
        activeTierKey = displayTiers[0].key;
      } else {
        const shouldSkipAutoAll = settings.showAllTab
          && settings.doNotAutoSelectAll
          && settings.defaultTab === 'all';
        activeTierKey = shouldSkipAutoAll
          ? '__none__'
          : (settings.showAllTab ? 'all' : (getDisplayTiers()[0] ? getDisplayTiers()[0].key : 'all'));
      }
    }

    setActiveTab(activeTierKey);
  }

  function renderTabs() {
    elements.tabs.hidden = false;
    elements.tabs.innerHTML = '';
    tabButtons.clear();
    tabCounts.clear();

    if (settings.showAllTab) {
      const allTab = createTabButton(settings.allLabel, 'all');
      elements.tabs.appendChild(allTab);
    }

    getDisplayTiers().forEach(tier => {
      const tab = createTabButton(tier.label, tier.key);
      elements.tabs.appendChild(tab);
    });
  }

  function createTabButton(label, key) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cm-nav__tab';
    btn.setAttribute('role', 'tab');
    btn.dataset.tierKey = key;

    const labelSpan = document.createElement('span');
    labelSpan.className = 'cm-nav__tab-label';
    labelSpan.textContent = label;

    const countSpan = document.createElement('span');
    countSpan.className = 'cm-nav__count';

    btn.appendChild(labelSpan);
    if (settings.showCounts) {
      btn.appendChild(countSpan);
      tabCounts.set(key, countSpan);
    }

    tabButtons.set(key, btn);
    return btn;
  }

  function setActiveTab(key) {
    activeTierKey = key;
    tabButtons.forEach((btn, btnKey) => {
      const isActive = key !== '__none__' && btnKey === key;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.classList.toggle('is-active', isActive);
      btn.tabIndex = isActive ? 0 : -1;
    });
  }

  function refresh(forceSort) {
    if (!sectionStates.length) return;

    const sortKey = elements.sort ? elements.sort.value : settings.defaultSort;
    if (forceSort || sortKey !== lastSortKey) {
      if (sortKey === 'completed-first' || sortKey === 'incomplete-first') {
        updateCompletion(sectionStates);
      }
      sectionStates.forEach(state => applySortToSection(state, sortKey));
      lastSortKey = sortKey;
    }

    const query = elements.search ? elements.search.value.trim().toLowerCase() : '';
    const queryActive = query !== '';
    if (elements.clear) elements.clear.hidden = query === '';

    if (useCustomTabs) {
      refreshCustomTabView(query, queryActive);
      return;
    }

    refreshSectionTabView(query, queryActive);
  }

  function refreshSectionTabView(query, queryActive) {
    const matches = new Map();
    let visibleCount = 0;
    let totalCount = 0;

    tiers.forEach(tier => {
      let tierTotal = 0;
      let tierMatch = 0;

      tier.sections.forEach(sectionState => {
        const sectionItems = sectionState.items;
        const isActiveTier = activeTierKey === 'all' || activeTierKey === '__none__' || tier.key === activeTierKey;
        let sectionMatch = 0;
        let sectionTotal = 0;

        sectionItems.forEach(item => {
          const matchesSearch = query === '' || item.search.indexOf(query) !== -1;
          const hiddenByHeading = item.el.dataset.cmCollapsedByHeading === 'true';
          const isMatch = query === ''
            ? (matchesSearch && !hiddenByHeading)
            : matchesSearch;

          tierTotal += 1;
          sectionTotal += 1;
          if (matchesSearch) tierMatch += 1;

          if (isActiveTier) {
            setCourseNavVisibility(item.el, isMatch);
            if (isMatch) sectionMatch += 1;
          }
        });

        if (isActiveTier) {
          totalCount += sectionTotal;
          const shouldShowSection = queryActive ? sectionMatch > 0 : true;
          setCourseNavVisibility(sectionState.section, shouldShowSection);
          syncSearchSectionAccordionState(sectionState.section, queryActive, shouldShowSection);
          visibleCount += sectionMatch;
          updateHeadingVisibility(sectionState, query);
        } else {
          setCourseNavVisibility(sectionState.section, false);
          syncSearchSectionAccordionState(sectionState.section, false, false);
        }
      });

      matches.set(tier.key, query ? tierMatch : tierTotal);
    });

    if (settings.showCounts) {
      updateTabCounts(matches);
    }

    if (elements.meta && settings.showCounts) {
      elements.meta.textContent = `Showing ${query ? visibleCount : totalCount} of ${totalCount} modules`;
      elements.meta.hidden = false;
    }

    if (elements.empty) {
      if (query && visibleCount === 0) {
        elements.empty.textContent = settings.emptyMessage;
        elements.empty.hidden = false;
      } else {
        elements.empty.hidden = true;
      }
    }
  }

  function refreshCustomTabView(query, queryActive) {
    const allActive = activeTierKey === 'all' || activeTierKey === '__none__';
    const matches = new Map();
    let visibleCount = 0;
    let totalCount = 0;
    let allCount = 0;

    tiers.forEach(tier => {
      matches.set(tier.key, 0);
    });

    sectionStates.forEach(sectionState => {
      let sectionVisible = 0;
      let sectionTotalForTab = 0;

      sectionState.items.forEach(item => {
        const matchesSearch = query === '' || item.search.indexOf(query) !== -1;
        const hiddenByHeading = item.el.dataset.cmCollapsedByHeading === 'true';
        const inActiveTab = allActive || item.tabKeys.includes(activeTierKey);
        const visibleByQuery = query === ''
          ? (matchesSearch && !hiddenByHeading)
          : matchesSearch;
        const isVisible = inActiveTab && visibleByQuery;
        const countable = query ? matchesSearch : true;

        if (countable) {
          allCount += 1;
          item.tabKeys.forEach(tabKey => {
            if (!matches.has(tabKey)) return;
            matches.set(tabKey, (matches.get(tabKey) || 0) + 1);
          });
        }

        setCourseNavVisibility(item.el, isVisible);

        if (inActiveTab) {
          sectionTotalForTab += 1;
          totalCount += 1;
          if (isVisible) sectionVisible += 1;
        }
      });

      const shouldShowSection = queryActive ? sectionVisible > 0 : sectionTotalForTab > 0;
      setCourseNavVisibility(sectionState.section, shouldShowSection);
      syncSearchSectionAccordionState(sectionState.section, queryActive, shouldShowSection);
      visibleCount += sectionVisible;
      updateHeadingVisibilityForCustomTabs(sectionState, query, activeTierKey);
    });

    if (settings.showCounts) {
      updateTabCounts(matches, allCount);
    }

    if (elements.meta && settings.showCounts) {
      elements.meta.textContent = `Showing ${query ? visibleCount : totalCount} of ${totalCount} modules`;
      elements.meta.hidden = false;
    }

    if (elements.empty) {
      if (query && visibleCount === 0) {
        elements.empty.textContent = settings.emptyMessage;
        elements.empty.hidden = false;
      } else {
        elements.empty.hidden = true;
      }
    }
  }

  function updateTabCounts(matches, allCount) {
    tabCounts.forEach((el, key) => {
      const count = key === 'all'
        ? (typeof allCount === 'number'
          ? allCount
          : Array.from(matches.values()).reduce((sum, value) => sum + value, 0))
        : (matches.get(key) || 0);
      el.textContent = `(${count})`;
    });
  }

  if (elements.sort) {
    elements.sort.value = settings.defaultSort;
    elements.sort.addEventListener('change', () => refresh(true));
  }

  if (elements.search) {
    const onSearch = debounceCourseNav(() => refresh(false), 150);
    elements.search.addEventListener('input', onSearch);
    elements.search.addEventListener('search', onSearch);
  }

  if (elements.clear) {
    elements.clear.addEventListener('click', () => {
      if (elements.search) elements.search.value = '';
      refresh(false);
    });
    elements.clear.hidden = true;
  }

  if (elements.tabs && settings.showTabs) {
    elements.tabs.addEventListener('click', e => {
      const button = e.target.closest('[data-tier-key]');
      if (!button) return;
      const nextKey = button.dataset.tierKey;
      const shouldDeselect = activeTierKey === nextKey;
      setActiveTab(shouldDeselect ? '__none__' : nextKey);
      refresh(false);
    });
  }

  rebuild();
  refresh(true);

  return { rebuild, refresh };
}

function buildCourseSectionStates(courseId) {
  if (!courseId) return [];

  const sections = Array.from(document.querySelectorAll('.cm-section[data-course-id]'))
    .filter(section => normalizeCourseKey(section.dataset.courseId) === courseId);

  return sections.map((section, index) => {
    const list = section.querySelector('.cm-list');
    if (!list) return null;

    const orphanedGroups = Array.from(list.children).filter(node => {
      return node.nodeType === 1 && node.classList.contains('cm-group');
    });
    orphanedGroups.forEach(group => {
      while (group.firstChild) {
        list.insertBefore(group.firstChild, group);
      }
      group.remove();
    });

    const nodes = Array.from(list.children).filter(node => node.nodeType === 1);
    const itemEls = nodes.filter(node => node.classList.contains('cm-item'));
    const headingEls = nodes.filter(node => node.classList.contains('cm-heading-block'));

    const sectionId = section.dataset.sectionId || section.id || `cm-${index}`;
    const customerId = section.dataset.customerId || 'guest';
    const sectionKey = normalizeCourseKey(sectionId) || `section-${index + 1}`;

    const items = itemEls.map((el, itemIndex) => {
      const order = parseInt(el.dataset.cmOrder, 10);
      const headingIndex = parseInt(el.dataset.headingIndex || '0', 10);
      const title = (el.dataset.title || (el.querySelector('.cm-title') ? el.querySelector('.cm-title').textContent : '') || '').trim();
      const search = (el.dataset.search || title).toLowerCase().trim();
      const locked = el.dataset.locked === 'true';
      const blockId = el.dataset.blockId || '';
      const tabKeys = Array.from(new Set(
        String(el.dataset.tabs || '')
          .split(',')
          .map(value => normalizeCourseKey(value))
          .filter(Boolean)
      ));

      return {
        el: el,
        order: Number.isNaN(order) ? itemIndex : order,
        headingIndex: Number.isNaN(headingIndex) ? 0 : headingIndex,
        title: title,
        titleLower: title.toLowerCase(),
        search: search,
        locked: locked,
        tabKeys: tabKeys,
        storageKey: `cm:${sectionId}:${blockId}:completed:${customerId}`,
        completed: false
      };
    });

    const groups = new Map();
    items.forEach(item => {
      const key = item.headingIndex;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });

    const headings = new Map();
    headingEls.forEach(el => {
      const idx = parseInt(el.dataset.headingIndex, 10);
      if (!Number.isNaN(idx)) headings.set(idx, el);
    });

    const orderedNodes = nodes
      .filter(node => node.classList.contains('cm-item') || node.classList.contains('cm-heading-block'))
      .map((el, nodeIndex) => {
        const order = parseInt(el.dataset.cmOrder, 10);
        return { el: el, order: Number.isNaN(order) ? nodeIndex : order };
      });

    return {
      section: section,
      sectionKey: sectionKey,
      list: list,
      items: items,
      groups: groups,
      headings: headings,
      headingOrder: Array.from(headings.keys()).sort((a, b) => a - b),
      orderedNodes: orderedNodes,
      tierLabel: (section.dataset.tierLabel || section.dataset.sectionTitle || '').trim(),
      tierKey: normalizeCourseKey(section.dataset.tierKey || section.dataset.tierLabel || section.dataset.sectionTitle || section.id),
      tierOrder: parseInt(section.dataset.tierOrder, 10),
      index: index
    };
  }).filter(Boolean);
}

function buildTierGroups(sectionStates) {
  return sectionStates.map((state, index) => {
    const label = (state.section.dataset.sectionTitle || state.tierLabel || `Section ${index + 1}`).trim();
    return {
      key: state.sectionKey || normalizeCourseKey(state.section.dataset.sectionId || state.section.id || `section-${index + 1}`) || `section-${index + 1}`,
      label: label || `Section ${index + 1}`,
      order: Number.isNaN(state.tierOrder) ? state.index : state.tierOrder,
      sections: [state]
    };
  }).sort((a, b) => {
    const orderA = Number.isNaN(a.order) ? 9999 : a.order;
    const orderB = Number.isNaN(b.order) ? 9999 : b.order;
    if (orderA !== orderB) return orderA - orderB;
    return a.label.localeCompare(b.label);
  });
}

function buildCustomTabGroups(customTabs) {
  return customTabs
    .slice()
    .sort((a, b) => a.order - b.order)
    .map(tab => ({
      key: tab.key,
      label: tab.label,
      order: tab.order,
      sections: []
    }));
}

function applySortToSection(sectionState, sortKey) {
  if (!sectionState.list) return;

  const frag = document.createDocumentFragment();

  if (sortKey === 'default') {
    sectionState.orderedNodes
      .slice()
      .sort((a, b) => a.order - b.order)
      .forEach(node => frag.appendChild(node.el));
    sectionState.list.appendChild(frag);
    return;
  }

  if (sectionState.headings.size) {
    if (sectionState.groups.has(0)) {
      sortGroup(sectionState.groups.get(0), sortKey).forEach(item => frag.appendChild(item.el));
    }

    sectionState.headingOrder.forEach(headingIndex => {
      const heading = sectionState.headings.get(headingIndex);
      if (heading) frag.appendChild(heading);
      sortGroup(sectionState.groups.get(headingIndex) || [], sortKey).forEach(item => frag.appendChild(item.el));
    });
  } else {
    sortGroup(sectionState.items, sortKey).forEach(item => frag.appendChild(item.el));
  }

  sectionState.list.appendChild(frag);
}

function sortGroup(items, sortKey) {
  const sorted = items.slice();
  sorted.sort((a, b) => {
    if (sortKey === 'title-asc') {
      const result = a.titleLower.localeCompare(b.titleLower);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'title-desc') {
      const result = b.titleLower.localeCompare(a.titleLower);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'completed-first') {
      const result = (b.completed ? 1 : 0) - (a.completed ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'incomplete-first') {
      const result = (a.completed ? 1 : 0) - (b.completed ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'unlocked-first') {
      const result = (a.locked ? 1 : 0) - (b.locked ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    return a.order - b.order;
  });
  return sorted;
}

function updateHeadingVisibility(sectionState, query) {
  if (!sectionState.headings.size) return;

  sectionState.headings.forEach((heading, headingIndex) => {
    if (!query) {
      setCourseNavVisibility(heading, true);
      return;
    }
    const items = sectionState.groups.get(headingIndex) || [];
    const hasVisible = items.some(item => !item.el.hidden);
    setCourseNavVisibility(heading, hasVisible);
  });
}

function updateHeadingVisibilityForCustomTabs(sectionState, query, activeTabKey) {
  if (!sectionState.headings.size) return;

  const queryActive = query !== '';
  const allActive = activeTabKey === 'all' || activeTabKey === '__none__';

  sectionState.headings.forEach((heading, headingIndex) => {
    if (!queryActive && allActive) {
      setCourseNavVisibility(heading, true);
      return;
    }

    const items = sectionState.groups.get(headingIndex) || [];
    const hasMatch = items.some(item => {
      const inTab = allActive || item.tabKeys.includes(activeTabKey);
      if (!inTab) return false;
      if (!queryActive) return true;
      return item.search.indexOf(query) !== -1;
    });
    setCourseNavVisibility(heading, hasMatch);
  });
}

function updateCompletion(sectionStates) {
  sectionStates.forEach(sectionState => {
    sectionState.items.forEach(item => {
      item.completed = getCompletionState(item);
    });
  });
}

function getCompletionState(item) {
  if (!item.storageKey) return false;
  return getCourseProgressFromLocal(item.storageKey);
}
/* ========================= COURSE NAVIGATION JS END ========================= */

/* ========================== COURSE NOTES JS START ========================== */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-cm-notes-widget]')) return;
  runNonCritical(() => initCourseNotesWidgets({ target: document }), { timeout: 1800 });
});
document.addEventListener('shopify:section:load', initCourseNotesWidgets);

const cmNotesHydrationPromises = new Map();
const cmNotesWriteTimers = new Map();

function getCourseNotesStorageKey(widget) {
  if (!widget) return '';
  const widgetKey = String(widget.dataset.widgetKey || 'default').trim() || 'default';
  const courseId = String(widget.dataset.courseId || 'general').trim() || 'general';
  const customerId = String(widget.dataset.customerId || 'guest').trim() || 'guest';
  return `cm:notes:${widgetKey}:${courseId}:${customerId}`;
}

function safeCourseNotesRead(storageKey) {
  if (!storageKey) return '';
  try {
    return String(localStorage.getItem(storageKey) || '');
  } catch (err) {
    return '';
  }
}

function safeCourseNotesWrite(storageKey, value) {
  if (!storageKey) return false;
  try {
    localStorage.setItem(storageKey, String(value || ''));
    return true;
  } catch (err) {
    return false;
  }
}

function getCourseNotesEndpoint(widget) {
  if (!widget) return '';
  const raw = String(widget.dataset.notesEndpoint || '').trim();
  if (!raw) return '';
  return raw.startsWith('/') ? raw : `/${raw}`;
}

function shouldSyncCourseNotes(widget) {
  if (!widget) return false;
  const persist = String(widget.dataset.notesPersist || '').trim().toLowerCase();
  if (persist !== 'true') return false;
  const customerId = String(widget.dataset.customerId || 'guest').trim();
  if (!customerId || customerId === 'guest') return false;
  return getCourseNotesEndpoint(widget) !== '';
}

function buildCourseNotesSyncContext(widget) {
  const customerId = String(widget.dataset.customerId || 'guest').trim() || 'guest';
  const courseId = normalizeCourseKey(widget.dataset.courseId || '') || 'general';
  const widgetKey = String(widget.dataset.widgetKey || 'default').trim() || 'default';
  const endpoint = getCourseNotesEndpoint(widget);
  const noteKey = `${widgetKey}:${courseId}`;
  const canSync = shouldSyncCourseNotes(widget);

  return {
    canSync,
    endpoint,
    customerId,
    courseId,
    widgetKey,
    noteKey
  };
}

function mapCourseNotesPayload(payload, noteKey, widgetKey) {
  if (!payload || typeof payload !== 'object') return null;

  if (typeof payload.note === 'string') return payload.note;
  if (typeof payload.content === 'string') return payload.content;

  const notes = payload.notes;
  if (notes && typeof notes === 'object' && !Array.isArray(notes)) {
    if (typeof notes[noteKey] === 'string') return notes[noteKey];
    if (widgetKey && typeof notes[widgetKey] === 'string') return notes[widgetKey];
  }

  if (Array.isArray(payload.items)) {
    const match = payload.items.find(item => {
      if (!item || typeof item !== 'object') return false;
      const key = String(item.note_key || item.noteKey || '').trim();
      return key === noteKey || (widgetKey && key === widgetKey);
    });
    if (match && typeof match.content === 'string') return match.content;
  }

  return null;
}

function hydrateCourseNotesFromAccount(syncContext, storageKey, input, setStatus, updateMeta, hasUserTypedRef) {
  if (!syncContext || !syncContext.canSync) return;

  const { endpoint, customerId, courseId, noteKey, widgetKey } = syncContext;
  if (!endpoint || !customerId || !courseId || !noteKey) return;

  const hydrateKey = `${endpoint}|${customerId}|${courseId}|${noteKey}`;
  if (cmNotesHydrationPromises.has(hydrateKey)) return;

  let url;
  try {
    url = new URL(endpoint, window.location.origin);
  } catch (err) {
    return;
  }

  url.searchParams.set('course_id', courseId);
  url.searchParams.set('note_key', noteKey);
  url.searchParams.set('widget_key', widgetKey);

  const request = fetch(url.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(response => {
      if (!response.ok) throw new Error(`Notes hydrate failed: ${response.status}`);
      return response.json();
    })
    .then(payload => {
      if (hasUserTypedRef.current === true) return;
      const note = mapCourseNotesPayload(payload, noteKey, widgetKey);
      if (typeof note !== 'string') return;
      const localValue = String(input.value || '');
      const hasLocalValue = localValue.trim().length > 0;
      const hasRemoteValue = note.trim().length > 0;

      // Do not wipe valid local notes with an empty remote payload.
      if (!hasRemoteValue && hasLocalValue) {
        setStatus('Saved locally', false);
        return;
      }

      input.value = note;
      safeCourseNotesWrite(storageKey, note);
      updateMeta();
      setStatus('Synced', false);
    })
    .catch(() => {
      setStatus('Saved locally', false);
    })
    .finally(() => {
      cmNotesHydrationPromises.delete(hydrateKey);
    });

  cmNotesHydrationPromises.set(hydrateKey, request);
}

function queueCourseNotesAccountSync(syncContext, noteContent, setStatus) {
  if (!syncContext || !syncContext.canSync) return;

  const { endpoint, customerId, courseId, noteKey, widgetKey } = syncContext;
  if (!endpoint || !customerId || !courseId || !noteKey) return;

  const writeKey = `${endpoint}|${customerId}|${courseId}|${noteKey}`;
  if (cmNotesWriteTimers.has(writeKey)) {
    clearTimeout(cmNotesWriteTimers.get(writeKey));
  }

  const timer = setTimeout(() => {
    cmNotesWriteTimers.delete(writeKey);
    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        customer_id: customerId,
        course_id: courseId,
        widget_key: widgetKey,
        note_key: noteKey,
        content: noteContent || ''
      })
    })
      .then(response => {
        if (!response.ok) throw new Error(`Notes sync failed: ${response.status}`);
        setStatus('Synced', false);
      })
      .catch(() => {
        setStatus('Saved locally', false);
      });
  }, 240);

  cmNotesWriteTimers.set(writeKey, timer);
}

function initCourseNotesWidgets(event) {
  const root = event && event.target ? event.target : document;
  if (!root || !root.querySelectorAll) return;

  root.querySelectorAll('[data-cm-notes-widget]').forEach(widget => {
    if (widget.dataset.cmNotesInit === 'true') return;
    widget.dataset.cmNotesInit = 'true';

    const toggleBtn = widget.querySelector('[data-cm-notes-toggle]');
    const closeBtn = widget.querySelector('[data-cm-notes-close]');
    const clearBtn = widget.querySelector('[data-cm-notes-clear]');
    const backdrop = widget.querySelector('[data-cm-notes-backdrop]');
    const panel = widget.querySelector('[data-cm-notes-panel]');
    const input = widget.querySelector('[data-cm-notes-input]');
    const status = widget.querySelector('[data-cm-notes-status]');
    const count = widget.querySelector('[data-cm-notes-count]');
    const dot = widget.querySelector('[data-cm-notes-dot]');
    if (!toggleBtn || !panel || !input) return;

    const storageKey = getCourseNotesStorageKey(widget);
    const countSuffix = String(widget.dataset.countSuffix || 'characters').trim() || 'characters';
    const syncContext = buildCourseNotesSyncContext(widget);
    const hasUserTypedRef = { current: false };

    const setOpen = (nextOpen) => {
      widget.classList.toggle('is-open', nextOpen);
      toggleBtn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
      if (backdrop) backdrop.hidden = !nextOpen;
      if (nextOpen) {
        requestAnimationFrame(() => input.focus());
      }
    };

    const setStatus = (text, isSaving) => {
      if (!status) return;
      status.textContent = text;
      status.classList.toggle('is-saving', isSaving === true);
    };

    const updateMeta = () => {
      const value = input.value || '';
      const length = value.length;
      if (count) count.textContent = `${length} ${countSuffix}`;
      if (dot) dot.hidden = length === 0;
    };

    const save = () => {
      const ok = safeCourseNotesWrite(storageKey, input.value || '');
      if (!ok) {
        setStatus('Save failed', false);
        updateMeta();
        return;
      }

      if (syncContext.canSync) {
        setStatus('Syncing...', true);
        queueCourseNotesAccountSync(syncContext, input.value || '', setStatus);
      } else {
        setStatus('Saved', false);
      }
      updateMeta();
    };

    const initialValue = safeCourseNotesRead(storageKey);
    input.value = initialValue;
    updateMeta();
    setStatus(syncContext.canSync ? 'Syncing...' : 'Saved', false);
    setOpen(false);

    if (syncContext.canSync) {
      hydrateCourseNotesFromAccount(syncContext, storageKey, input, setStatus, updateMeta, hasUserTypedRef);
    }

    toggleBtn.addEventListener('click', () => setOpen(true));
    if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
    if (backdrop) backdrop.addEventListener('click', () => setOpen(false));

    input.addEventListener('input', () => {
      hasUserTypedRef.current = true;
      save();
    });
    input.addEventListener('blur', () => {
      save();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (!input.value) return;
        const shouldClear = window.confirm('Clear all notes?');
        if (!shouldClear) return;
        input.value = '';
        save();
      });
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && widget.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  });
}
/* =========================== COURSE NOTES JS END =========================== */




(function(){

  if(window.CourseGallery) return;

  function clamp(value,min,max){
    return Math.max(min,Math.min(max,value));
  }

  function getOrCreateCourseGalleryLightbox(){
    let lightbox=document.querySelector('.course-gallery-lightbox');
    if(lightbox) return lightbox;

    function closeLightbox(){
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
    }

    lightbox=document.createElement('div');
    lightbox.className='course-gallery-lightbox';
    lightbox.setAttribute('aria-hidden','true');
    lightbox.innerHTML='<button type="button" class="course-gallery-lightbox__close" aria-label="Close gallery">×</button><img src="" alt="">';
    document.body.appendChild(lightbox);

    lightbox.addEventListener('click',()=>{
      closeLightbox();
    });

    const closeButton=lightbox.querySelector('.course-gallery-lightbox__close');
    const image=lightbox.querySelector('img');

    if(closeButton){
      closeButton.addEventListener('click',event=>{
        event.stopPropagation();
        closeLightbox();
      });
    }

    if(image){
      image.addEventListener('click',event=>{
        event.stopPropagation();
      });
    }

    document.addEventListener('keydown',event=>{
      if(event.key!=='Escape') return;
      closeLightbox();
    });

    return lightbox;
  }

  function initSingleCourseGallery(gallery){
    if(gallery.dataset.init==='true') return;
    gallery.dataset.init='true';

    const isCarousel=gallery.dataset.layout==='carousel';
    const lightboxEnabled=gallery.dataset.lightbox!=='false';
    const viewport=gallery.querySelector('[data-gallery-viewport]');
    const track=gallery.querySelector('[data-gallery-track]');
    const slides=Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const prev=gallery.querySelector('[data-gallery-prev]');
    const next=gallery.querySelector('[data-gallery-next]');
    const dots=Array.from(gallery.querySelectorAll('[data-gallery-dot]'));

    if(isCarousel && viewport && slides.length){
      const maxIndex=Math.max(slides.length-1,0);

      function getSlideStep(){
        const firstSlide=slides[0];
        if(!firstSlide) return 0;

        const slideWidth=firstSlide.getBoundingClientRect().width;
        let gap=0;
        if(track){
          const styles=window.getComputedStyle(track);
          gap=parseFloat(styles.columnGap || styles.gap || '0') || 0;
        }

        return slideWidth + gap;
      }

      function getActiveIndex(){
        const step=getSlideStep();
        if(!step) return 0;
        return clamp(Math.round(viewport.scrollLeft / step),0,maxIndex);
      }

      function scrollToIndex(index){
        const step=getSlideStep();
        if(!step) return;
        const target=clamp(index,0,maxIndex);
        viewport.scrollTo({
          left:target*step,
          behavior:'smooth'
        });
      }

      function updateControls(){
        const index=getActiveIndex();

        dots.forEach((dot,dotIndex)=>{
          dot.classList.toggle('is-active',dotIndex===index);
        });

        if(prev) prev.disabled=index<=0;
        if(next) next.disabled=index>=maxIndex;
      }

      if(prev){
        prev.addEventListener('click',()=>{
          scrollToIndex(getActiveIndex()-1);
        });
      }

      if(next){
        next.addEventListener('click',()=>{
          scrollToIndex(getActiveIndex()+1);
        });
      }

      dots.forEach(dot=>{
        dot.addEventListener('click',()=>{
          const dotIndex=parseInt(dot.dataset.index,10);
          if(Number.isNaN(dotIndex)) return;
          scrollToIndex(dotIndex);
        });
      });

      let ticking=false;
      viewport.addEventListener('scroll',()=>{
        if(ticking) return;
        ticking=true;
        window.requestAnimationFrame(()=>{
          ticking=false;
          updateControls();
        });
      },{ passive:true });

      window.addEventListener('resize',updateControls);
      updateControls();
    }

    if(!lightboxEnabled) return;

    gallery.querySelectorAll('[data-gallery-open]').forEach(button=>{
      button.addEventListener('click',()=>{
        const imageSrc=button.dataset.imageSrc;
        if(!imageSrc) return;

        const lightbox=getOrCreateCourseGalleryLightbox();
        const lightboxImage=lightbox.querySelector('img');
        if(!lightboxImage) return;

        lightboxImage.src=imageSrc;
        lightboxImage.alt=button.dataset.imageAlt || '';
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden','false');
      });
    });
  }

  window.CourseGallery={
    init:function(root){
      const scope=root || document;
      scope.querySelectorAll('[data-course-gallery]').forEach(initSingleCourseGallery);
    }
  };

  document.addEventListener('DOMContentLoaded',()=>{
    window.CourseGallery.init(document);
  });

  document.addEventListener('shopify:section:load',event=>{
    window.CourseGallery.init(event.target || document);
  });

})();
